import * as React from 'react';
/**
 *
 * Original name: Windows
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=4068%3A1924
 *
 */
export const WindowsExternalLogo = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m4 6.255 6.489-.884.002 6.259-6.485.037L4 6.255Zm6.486 6.096.005 6.264-6.486-.891v-5.415l6.48.042Zm.786-7.095L19.875 4v7.55l-8.603.069V5.256Zm8.605 7.154-.002 7.516-8.603-1.214-.012-6.316 8.617.014Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
